import { render, staticRenderFns } from "./changePasswordForm.vue?vue&type=template&id=b0a8771a&scoped=true"
import script from "./changePasswordForm.vue?vue&type=script&lang=js"
export * from "./changePasswordForm.vue?vue&type=script&lang=js"
import style0 from "./changePasswordForm.vue?vue&type=style&index=0&id=b0a8771a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a8771a",
  null
  
)

export default component.exports